// extracted by mini-css-extract-plugin
export var indexHolder = "index-module--indexHolder--L+J1c";